import { render, staticRenderFns } from "./NavbarMobile.vue?vue&type=template&id=0ba453fa"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports